import {Droplets} from 'lucide-react'
import { useCalculator } from "@/context/CalculatorContext"

export default function SourdoughCard() {
  const {
    targetHydration,
    starterRatio,
    setTargetHydration,
    setStarterRatio,
    applySourdoughHydration,
    flourWeight,
  } = useCalculator()

  const starterWeight = flourWeight > 0 ? ((starterRatio / 100) * flourWeight).toFixed(0) : "—"
  const starterFlour = flourWeight > 0 ? (((starterRatio / 100) * flourWeight) / 2).toFixed(0) : "—"
  const starterWater = starterFlour

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5 card-hover">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-9 h-9 bg-orange-50 rounded-lg flex items-center justify-center flex-shrink-0">
          <Droplets size={17} className="text-orange-600" strokeWidth={2.2} />
        </div>
        <div>
          <h2 className="text-base font-semibold text-gray-900 leading-tight">Sourdough Hydration Calculator</h2>
          <p className="text-xs text-gray-500 mt-0.5">
            Assumes 100% hydration starter (50% water / 50% flour)
          </p>
        </div>
      </div>

      {/* Target Hydration Slider */}
      <div className="mb-5">
        <div className="flex items-center justify-between mb-2">
          <label className="text-xs font-semibold text-gray-600 uppercase tracking-wider">
            Target Dough Hydration
          </label>
          <span className="text-sm font-bold text-indigo-700 tabular-nums bg-indigo-50 px-2 py-0.5 rounded-md border border-indigo-200">
            {targetHydration.toFixed(0)}%
          </span>
        </div>
        <input
          type="range"
          min="40"
          max="100"
          step="1"
          value={targetHydration}
          onChange={(e) => setTargetHydration(Number(e.target.value))}
          className="w-full accent-indigo-600"
          style={{
            background: `linear-gradient(to right, #4F46E5 0%, #4F46E5 ${((targetHydration - 40) / 60) * 100}%, #E5E7EB ${((targetHydration - 40) / 60) * 100}%, #E5E7EB 100%)`,
          }}
        />
        <div className="flex justify-between text-xs text-gray-400 mt-1">
          <span>40%</span>
          <span>70%</span>
          <span>100%</span>
        </div>
      </div>

      {/* Starter Ratio Slider */}
      <div className="mb-5">
        <div className="flex items-center justify-between mb-2">
          <label className="text-xs font-semibold text-gray-600 uppercase tracking-wider">
            Starter Preferment Ratio
          </label>
          <span className="text-sm font-bold text-indigo-700 tabular-nums bg-indigo-50 px-2 py-0.5 rounded-md border border-indigo-200">
            {starterRatio.toFixed(0)}%
          </span>
        </div>
        <input
          type="range"
          min="0"
          max="50"
          step="1"
          value={starterRatio}
          onChange={(e) => setStarterRatio(Number(e.target.value))}
          className="w-full"
          style={{
            background: `linear-gradient(to right, #4F46E5 0%, #4F46E5 ${(starterRatio / 50) * 100}%, #E5E7EB ${(starterRatio / 50) * 100}%, #E5E7EB 100%)`,
          }}
        />
        <div className="flex justify-between text-xs text-gray-400 mt-1">
          <span>0%</span>
          <span>25%</span>
          <span>50%</span>
        </div>
      </div>

      {/* Starter Breakdown Preview */}
      {starterRatio > 0 && (
        <div className="bg-amber-50 border border-amber-100 rounded-lg px-4 py-3 mb-4 text-xs animate-fade-up">
          <p className="font-semibold text-amber-700 mb-2">Starter Breakdown</p>
          <div className="grid grid-cols-3 gap-2 text-center">
            <div>
              <p className="text-amber-600 font-bold tabular-nums">{starterWeight}g</p>
              <p className="text-amber-500">Total</p>
            </div>
            <div>
              <p className="text-amber-600 font-bold tabular-nums">{starterFlour}g</p>
              <p className="text-amber-500">Hidden Flour</p>
            </div>
            <div>
              <p className="text-amber-600 font-bold tabular-nums">{starterWater}g</p>
              <p className="text-amber-500">Hidden Water</p>
            </div>
          </div>
        </div>
      )}

      <button
        onClick={applySourdoughHydration}
        disabled={flourWeight <= 0}
        className="w-full bg-indigo-600 text-white text-sm font-semibold py-2.5 px-4 rounded-lg hover:bg-indigo-700 active:scale-[0.98] transition-all disabled:opacity-40 disabled:cursor-not-allowed shadow-sm hover:shadow"
      >
        Apply Sourdough Hydration
      </button>
    </div>
  )
}
